import { escapeHtml } from '../core/html.js?v=6.87.12';
import { commandEnvelope } from '../core/command.js?v=6.87.12';
import { passwordField, togglePasswordVisibility } from '../ui/presentation.js?v=6.87.16';

export class LoginController {
  constructor({ root, api, onAuthenticated, onError, initialMessage = '' }) {
    this.root = root;
    this.api = api;
    this.onAuthenticated = onAuthenticated;
    this.onError = onError;
    this.initialMessage = String(initialMessage || '');
    this.saving = false;
    this.requesting = false;
    this.mounted = false;
    this.boundSubmit = (event) => this.submit(event);
    this.boundClick = (event) => this.click(event);
  }

  mount() {
    this.mounted = true;
    this.root.innerHTML = `<main id="rc5-main" class="rc5-login">
      <div class="rc5-auth-scene" aria-hidden="true"><span></span><span></span><span></span></div>
      <section class="rc5-auth-card" aria-labelledby="rc5-login-title">
        <div class="rc5-auth-brand"><span class="rc5-auth-brand__mark" aria-hidden="true">⚓</span><div><strong>FleetOps CRM</strong><small>Операционный центр флота</small></div></div>
        <form class="rc5-auth-form" data-login-form autocomplete="on">
          <header class="rc5-auth-heading"><h1 id="rc5-login-title">Вход в систему</h1><p>Введите данные своей учётной записи.</p></header>
          <label><span>Логин</span><input name="login" maxlength="50" autocomplete="username" required data-focus-key="login" autofocus></label>
          <label><span>Пароль</span>${passwordField('<input name="password" type="password" autocomplete="current-password" required>')}</label>
          <button class="rc5-primary-action" type="submit">Войти</button>
          <p class="rc5-form-status" data-login-status role="status" aria-live="polite"></p>
        </form>
        <details class="rc5-access-panel"><summary>Нет учётной записи? Запросить доступ</summary><form class="rc5-auth-form rc5-auth-form--secondary" data-access-request-form><label><span>Желаемый логин</span><input name="login" maxlength="50" required></label><button type="submit">Отправить заявку</button><p class="rc5-form-status" data-request-status role="status" aria-live="polite"></p></form></details>
        <footer class="rc5-auth-footer">FleetOps CRM</footer>
      </section>
    </main>`;
    this.root.addEventListener('submit', this.boundSubmit);
    this.root.addEventListener('click', this.boundClick);
    if (this.initialMessage) this.setStatus(this.root.querySelector('[data-login-status]'), this.initialMessage, 'error');
  }

  destroy() {
    this.mounted = false;
    this.root.removeEventListener('submit', this.boundSubmit);
    this.root.removeEventListener('click', this.boundClick);
  }

  click(event) {
    const toggle = event.target.closest('[data-password-toggle]');
    if (toggle) togglePasswordVisibility(toggle);
  }

  setStatus(node, message, type = 'info') {
    if (!node) return;
    node.textContent = String(message || '');
    node.dataset.statusType = String(type || 'info');
  }

  async submit(event) {
    if (event.target.matches('[data-login-form]')) {
      event.preventDefault();
      await this.submitLogin(event.target);
      return;
    }
    if (event.target.matches('[data-access-request-form]')) {
      event.preventDefault();
      await this.submitAccessRequest(event.target);
    }
  }

  async submitLogin(form) {
    if (this.saving) return;
    const data = Object.fromEntries(new FormData(form).entries());
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-login-status]');
    this.saving = true;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    this.setStatus(status, 'Проверка данных…');
    try {
      const result = await this.api.call('auth.login', {
        login: String(data.login || ''),
        password: String(data.password || ''),
      });
      this.api.setCsrfToken(result.csrf_token);
      this.setStatus(status, result.user?.must_change_password
        ? 'Вход выполнен. Открываем смену временного пароля…'
        : 'Вход выполнен. Открываем CRM…', 'success');
      await this.onAuthenticated(result);
    } catch (error) {
      this.setStatus(status, error?.message || 'Не удалось выполнить вход.', 'error');
      this.onError(error);
    } finally {
      this.saving = false;
      if (button.isConnected) button.disabled = false;
      if (form.isConnected) form.removeAttribute('aria-busy');
    }
  }

  async submitAccessRequest(form) {
    if (this.requesting) return;
    const data = Object.fromEntries(new FormData(form).entries());
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-request-status]');
    this.requesting = true;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    this.setStatus(status, 'Отправка…');
    try {
      await this.api.call('access-request.create', {
        ...commandEnvelope('access-request-submit'),
        login: String(data.login || ''),
      });
      form.reset();
      this.setStatus(status, 'Заявка отправлена. Администратор свяжется с вами.', 'success');
    } catch (error) {
      this.setStatus(status, error?.message || 'Не удалось отправить заявку.', 'error');
      this.onError(error);
    } finally {
      this.requesting = false;
      if (button.isConnected) button.disabled = false;
      if (form.isConnected) form.removeAttribute('aria-busy');
    }
  }
}
